import { Capacitor } from '@capacitor/core';

export const isNative = Capacitor.isNativePlatform();

export const config = {
  tenantId: import.meta.env.VITE_ENTRA_TENANT_ID || '',
  clientId: import.meta.env.VITE_ENTRA_CLIENT_ID || '',
  // Web: same origin. Android app: the bundle runs from https://localhost, so
  // it must name the real server.
  apiBase: import.meta.env.VITE_API_BASE_URL || (isNative ? 'https://nano.nanoutilities.co.uk' : ''),
};

export const configured = Boolean(config.tenantId && config.clientId);
